export default __webpack_public_path__ + "static/media/article_one.23bda8e3.jpg";